
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/box/answers",
      function () {
        return require("private-next-pages/box/answers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/box/answers"])
      });
    }
  